module.exports = __webpack_public_path__ + "static/media/Italy-day.3429f8cc.svg";